import {Radial} from '@crema/modules/thirdParty';

export default Radial;
